import type { CityConfig } from "../city-template/types";

export const terreHauteConfig: CityConfig = {
  city: "Terre Haute",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "terre-haute",
  route: "/cities/terre-haute",
  title: "Emergency Passport Terre Haute IN | Expedited Vigo County Near Indianapolis | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Terre Haute, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Terre Haute, Clinton, Rockville, Sullivan, and all Vigo County residents. A+ BBB rated courier service with access to the Indianapolis Passport Agency.",
  h1: "Emergency & Expedited Passport Services in Terre Haute, IN",
  heroSubtitle: "Terre Haute travelers — from Indiana State University students heading abroad to Vigo County professionals bound for international meetings and Wabash Valley families planning overseas vacations — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Indianapolis Passport Agency, an easy drive east on I-70.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Terre%20Haute%20Indiana%20Wabash%20River%20waterfront%20at%20golden%20hour%20with%20Indiana%20State%20University%20campus%20in%20the%20distance%2C%20the%20historic%20Vigo%20County%20Courthouse%20with%20its%20iconic%20dome%20in%20downtown%20Terre%20Haute%2C%20the%20Clabber%20Girl%20Museum%20and%20downtown%20streetscape%20along%20Wabash%20Avenue%2C%20the%20CANDLES%20Holocaust%20Museum%20and%20the%20Swope%20Art%20Museum%2C%20rich%20amber%20sunset%20over%20the%20Wabash%20Valley%20with%20warm%20golden%20tones%20and%20historic%20charm%2C%20atmospheric%20twilight%20photography%20with%20cinematic%20depth%20of%20field%2C%20no%20text%20or%20people%2C%20wide%20landscape%20composition&width=1800&height=700&seq=terre-haute-hero-001&orientation=landscape",
  heroImageAlt: "Terre Haute Indiana with Wabash River and historic Vigo County Courthouse at sunset",
  geoPosition: "39.4667;-87.4139",
  geoPlacename: "Terre Haute, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Indianapolis Passport Agency",
    address: "575 N Pennsylvania St, Indianapolis, IN 46204",
    distance: "Approximately 75 miles east of Terre Haute via I-70 — about 1 hour 15 minutes",
  },
  nearbyCitiesZips: [
    { name: "Terre Haute", zips: "47802, 47803, 47804, 47805, 47807" },
    { name: "Clinton", zips: "47842" },
    { name: "Rockville", zips: "47872" },
    { name: "Sullivan", zips: "47882" },
    { name: "Brazil", zips: "47834" },
    { name: "Marshall", zips: "47859" },
    { name: "Jasonville", zips: "47438" },
    { name: "Linton", zips: "47441" },
    { name: "Greencastle", zips: "46135" },
    { name: "Paris", zips: "61944" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Direct courier to Indianapolis Passport Agency — just over an hour from Terre Haute via I-70" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Vigo County" },
    { icon: "ri-building-line", title: "Wabash Valley Access", desc: "Serving Terre Haute, Clinton, Rockville, Sullivan, and all West Central Indiana" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — or same-day hand delivery to Indianapolis Passport Agency" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Emergency passport help in Bloomington, IN", route: "/cities/bloomington-in" },
    { name: "Passport services in Carmel, IN", route: "/cities/carmel" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Terre Haute, Indiana via secure registered courier to the Indianapolis Passport Agency (575 N Pennsylvania St, Indianapolis). Approximately 75 miles — about 1 hour 15 minutes via I-70. Terre Haute's location on the Indiana-Illinois border makes it the primary passport hub for West Central Indiana and the Wabash Valley.",
  fpcOfficeDistance: "Serving Terre Haute, Clinton, Rockville, Sullivan, Brazil, Marshall, Jasonville, Linton, Greencastle, and all of Vigo County and the Wabash Valley region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Terre Haute and Vigo County. From the Indiana State University campus and downtown Terre Haute along Wabash Avenue to the historic Farrington's Grove neighborhood and Honey Creek Mall — we serve all of West Central Indiana with reliable access to the Indianapolis Passport Agency.",
  nearbyCitiesIntro: "We serve Terre Haute and all nearby communities including Clinton, Rockville, Sullivan, Brazil, Marshall, Jasonville, Linton, Greencastle, and neighboring Paris, Illinois. We also serve all of Vigo County and the greater Wabash Valley region.",
  howItWorksIntro: "Most Terre Haute travelers complete everything online and ship documents overnight. Our registered courier hand-delivers directly to the Indianapolis Passport Agency — just over an hour east on I-70. For urgent cases, same-day handoff eliminates the drive for you.",
  mistakesIntro: "Terre Haute sits at the crossroads of Indiana, Illinois, and the Wabash Valley. Here are the most common passport mistakes we see from travelers in this region.",
  testimonialsIntro: "Terre Haute travelers — from ISU students preparing for study abroad to Vigo County business professionals to Wabash Valley families — trust us when their departure is just days away.",
  faqIntro: "Have questions about expedited passports in Terre Haute, IN? Here are the most common ones we hear from Vigo County and West Central Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must visit Indianapolis Passport Agency in person", "75-minute drive from Terre Haute via I-70"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Indianapolis Passport Agency — just over an hour from Terre Haute", "Fastest access to passport agency in West Central Indiana", "Perfect for ISU study abroad students and faculty", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Indianapolis Passport Agency — just over an hour from Terre Haute", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Terre Haute travelers with immediate departure needs — as fast as 24 hours. Our couriers hand-deliver to the Indianapolis Passport Agency — just over an hour from Terre Haute via I-70.",
      bullets: ["24–48 hour turnaround available", "Indianapolis Passport Agency — fastest access in West Central Indiana", "ISU student and Wabash Valley family support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Terre Haute adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle the Indianapolis agency delivery.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier to Indianapolis Passport Agency", "Returned to your Vigo County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Terre Haute residents — including ISU students and young adults in the Wabash Valley region.",
      bullets: ["Acceptance facility scheduling in Terre Haute or Brazil", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Terre Haute residents who lost their passport before international travel — fast turnaround leveraging Indianapolis proximity.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Terre Haute and Vigo County families traveling internationally with children.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Terre Haute and Vigo County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Terre Haute IN", description: "Urgent passport processing for Terre Haute Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Terre Haute IN", description: "Fast passport renewal for Terre Haute Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Terre Haute IN", description: "New passport application services for Terre Haute Indiana residents applying for their first passport." },
    { name: "Child Passport Terre Haute IN", description: "Minor passport services for Terre Haute Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Terre Haute, IN — ISU Campus",
      rating: 5,
      text: "Study abroad trip to Spain with only 8 days notice — my passport was expired. Fast Passport Center got my renewal done through Indianapolis in 3 days. Saved my semester abroad. Amazing service for ISU students.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David R.",
      location: "Terre Haute, IN — Farrington's Grove",
      rating: 5,
      text: "Business trip to Frankfurt with 5 days notice. Fast Passport Center handled everything — the Indianapolis Passport Agency is only 75 minutes away and their courier did the rest. Got my passport in 2 days.",
      service: "Emergency Passport",
    },
    {
      name: "Maria O.",
      location: "Clinton, IN",
      rating: 5,
      text: "Family vacation to Cancun — needed passports for me, my husband, and our daughter. Fast Passport Center processed all three in 5 days. The courier to Indianapolis made it seamless. Couldn't believe how smooth it was.",
      service: "Family Passport Bundle",
    },
    {
      name: "James T.",
      location: "Brazil, IN",
      rating: 5,
      text: "Lost my passport a week before a trip to London. Absolute panic mode. Fast Passport Center replaced it in 48 hours. The Indianapolis Passport Agency proximity saved the entire trip. Legendary service.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "terre-haute-1",
      name: "Terre Haute Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 W Margaret Ave",
      city: "Terre Haute",
      state: "IN",
      zip: "47802",
      phone: "(812) 232-1646",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Terre Haute, near Indiana State University campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Terre Haute acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient downtown location near ISU and the Vigo County Courthouse.",
      icon: "ri-mail-line",
    },
    {
      id: "terre-haute-2",
      name: "Terre Haute Post Office — South",
      type: "USPS Passport Acceptance Facility",
      address: "301 S 7th St",
      city: "Terre Haute",
      state: "IN",
      zip: "47807",
      phone: "(812) 232-1646",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Terre Haute, near Honey Creek Mall and I-70 access",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Secondary Terre Haute acceptance location. Convenient for south side residents and those near US-41/I-70 interchange. May have shorter wait times than the main office.",
      icon: "ri-mail-line",
    },
    {
      id: "terre-haute-3",
      name: "Brazil Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "227 W National Ave",
      city: "Brazil",
      state: "IN",
      zip: "47834",
      phone: "(812) 448-1911",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Brazil, approximately 15 miles northeast of Terre Haute",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Clay County acceptance facility. Convenient alternative for Brazil and eastern Clay County residents. Good backup when Terre Haute appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "terre-haute-4",
      name: "Rockville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "108 E York St",
      city: "Rockville",
      state: "IN",
      zip: "47872",
      phone: "(765) 569-5989",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rockville, approximately 25 miles north of Terre Haute",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Parke County acceptance facility. Serves northern Vigo County border communities. Near Turkey Run State Park area. Call first — limited passport hours may apply.",
      icon: "ri-mail-line",
    },
    {
      id: "terre-haute-5",
      name: "Greencastle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8 E Walnut St",
      city: "Greencastle",
      state: "IN",
      zip: "46135",
      phone: "(765) 653-5919",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Greencastle, approximately 35 miles east of Terre Haute",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Putnam County acceptance facility. Serves DePauw University and surrounding area. Convenient for communities between Terre Haute and Indianapolis along US-40/I-70 corridor.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 75 minutes to Indianapolis via I-70", fpc: "No — we deliver for you, same-day handoff" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Wabash Valley Advantage", agency: "Terre Haute is the closest Wabash Valley city to any passport agency", fpc: "We leverage the 75-min Indianapolis proximity for every client" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Terre Haute's proximity to Indianapolis (75 minutes via I-70) creates a false sense of security. Even though the Indianapolis Passport Agency is within driving distance, you still need an appointment — and they don't accept walk-ins. Start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in Terre Haute and Brazil sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background — no exceptions, no glasses, no shadows.",
    },
    {
      icon: "ri-roadster-line",
      title: "Underestimating I-70 Construction Delays",
      description: "I-70 between Terre Haute and Indianapolis frequently undergoes construction and can experience weather delays in winter. A 75-minute drive to the Indianapolis Passport Agency can easily become 2+ hours. Our courier service eliminates this stress entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. ISU study abroad students heading to Europe and Terre Haute travelers visiting Canada or Mexico often discover this requirement too late.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Expecting Services at the Illinois Border",
      description: "Terre Haute's location right on the Indiana-Illinois border can be confusing. Illinois residents near Paris should use Illinois passport resources. Indiana residents should use Vigo County acceptance facilities — not cross the state line for post office appointments.",
    },
    {
      icon: "ri-file-list-line",
      title: "Not Bringing Proper ID to Acceptance Facility",
      description: "First-time applicants at Terre Haute acceptance facilities must bring citizenship evidence, photo ID, AND a photocopy of both sides of their ID. Many applicants arrive without photocopies and get turned away. The Terre Haute Post Office doesn't provide copying services — bring copies ready.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Terre Haute or Vigo County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Terre Haute or Brazil." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Vigo County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Indianapolis Passport Agency — just over an hour from Terre Haute via I-70." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Terre Haute address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Terre Haute, IN?", a: "Fast Passport Center offers emergency passport processing in Terre Haute, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver to the Indianapolis Passport Agency (575 N Pennsylvania St, Indianapolis) — approximately 75 miles east via I-70. Terre Haute is the primary passport hub for West Central Indiana and the Wabash Valley." },
    { q: "Does Terre Haute have its own passport agency?", a: "No — Terre Haute does not have its own passport agency. The nearest regional passport agency is the Indianapolis Passport Agency at 575 N Pennsylvania St, Indianapolis — approximately 75 miles east (about 1 hour 15 minutes via I-70). Fast Passport Center's registered courier service handles the delivery for you." },
    { q: "Is Fast Passport Center faster than the Terre Haute Post Office?", a: "Yes — significantly faster. The Terre Haute Post Office processes applications via standard mail, which takes 8–11 weeks or 5–7 weeks even with expedited service. Fast Passport Center uses registered couriers for direct hand-delivery to the Indianapolis Passport Agency — as fast as 24–48 hours for emergencies." },
    { q: "What airports do Terre Haute travelers use for international flights?", a: "Indianapolis International Airport (IND) is approximately 75 miles east via I-70. Chicago O'Hare (ORD) is approximately 170 miles northwest. Most Terre Haute travelers use IND for domestic connections to larger hubs, though some choose O'Hare for direct international flights." },
    { q: "How much does an expedited passport cost in Terre Haute, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Terre Haute?", a: "Walgreens (2040 Lafayette Ave), CVS (1300 Wabash Ave), and Walmart (4430 S US Hwy 41) offer passport photo services in Terre Haute. The UPS Store in Terre Haute also provides passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve ISU students and faculty?", a: "Yes. We serve Indiana State University students, faculty, and staff for study abroad programs, faculty research travel, and international conference attendance. ISU's Center for Global Engagement recommends starting passport applications 3–4 months before program departure — but we can help with last-minute emergencies." },
    { q: "Can I visit the Indianapolis Passport Agency directly from Terre Haute?", a: "Yes, but you need an appointment — walk-ins are not accepted. The drive is approximately 75 minutes east on I-70. However, Fast Passport Center's registered courier service handles the delivery for you, so you don't need to make the drive or deal with the Indianapolis agency's limited appointment availability." },
  ],
  photoLocations: [
    { name: "Walgreens — Terre Haute", address: "2040 Lafayette Ave, Terre Haute, IN 47805", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Terre Haute", address: "1300 Wabash Ave, Terre Haute, IN 47807", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walmart — Terre Haute South", address: "4430 S US Hwy 41, Terre Haute, IN 47802", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Terre Haute", address: "5000 S 7th St, Terre Haute, IN 47802", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Terre Haute", address: "5436 S US Hwy 41, Terre Haute, IN 47802", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient south Terre Haute location near Honey Creek Mall and I-70 access.", featured: true },
    { name: "Indiana BMV — Brazil", address: "700 E National Ave, Brazil, IN 47834", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Alternative BMV in Brazil, Indiana. Full REAL ID processing available. Serves Clay County and northeastern Vigo County residents.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "75 minutes east of Terre Haute via I-70",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary international airport for Terre Haute travelers. Served by all major U.S. carriers with connections to global hubs. The closest airport with scheduled international service.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "HUF",
      name: "Terre Haute Regional Airport",
      distance: "5 minutes east of downtown Terre Haute",
      address: "581 S Airport St, Terre Haute, IN 47803",
      note: "Local airport serving Terre Haute and Vigo County. Primarily general aviation with limited charter service. No scheduled commercial flights. Good for private and business aviation.",
      flightUrl: "https://www.terrehauteairport.com/",
      flightLabel: "HUF Info",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 170 miles northwest of Terre Haute",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Alternative international gateway for Wabash Valley travelers. United and American Airlines hubs with extensive global connections. Requires a full day of travel to reach from Terre Haute.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Vigo County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Vigo County and all Indiana counties" },
    { label: "Vigo County Clerk: Marriage Licenses", url: "https://www.vigocounty.in.gov/", icon: "ri-heart-line", description: "Vigo County Clerk — marriage license records for Terre Haute and Vigo County" },
    { label: "Vigo County: Divorce Decrees", url: "https://www.vigocounty.in.gov/", icon: "ri-file-list-3-line", description: "Vigo County Clerk of Courts — divorce decree records for Terre Haute and Vigo County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Terre Haute address" },
  ],
};